import * as theme from "@zero/design-tokens/build/js/variables";
import styled, { css } from "styled-components";
import { Card } from "uol-host-react-ui";
import UHCDesignTokens from "@/shared/styles/DesignTokens.styles";
import { Badge } from "../../Molecules/Badge/Badge";

export type MenuProps = { mobile: number };

export const CardMenu = styled(Card)<MenuProps>`
  border-right: 8px solid ${UHCDesignTokens.color.ghost_uh};
  border-radius: 0px;
  
  ${({ mobile: mobileBreakPoint }) => css`
    @media (min-width: ${mobileBreakPoint}px) {
      border-right: unset !important;
      padding: 0px !important;
      box-shadow: unset !important;
      div:first-child {
        padding: 0px;
      }
    }
  `}
`;

export const Menu = styled.div<MenuProps>`
  width: 100%;

  ${({ mobile: mobileBreakPoint }) => css`
    header {
      box-shadow: none; //?
      background-color: #fff;

      .MuiTabs-indicator {
        display: none;
      }

      .MuiTabs-flexContainer {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }

      .MuiButtonBase-root {
        border: 1px solid #707070;
        border-radius: 3px;
        min-width: unset;
      }

      .Mui-selected {
        background-color: ${UHCDesignTokens.color.ghost_uh};
        color: #fff;
        border-top: unset;
        border-left: unset;
        border-right: unset;
        border-bottom: 2px solid #005160;
      }

      button {
        font-family: ${theme.ZrFontFamilyDigitalRegular};
        font-size: 16px;
        text-transform: none;
        padding: 0;
        min-height: 48px;
      }

      @media (min-width: ${mobileBreakPoint}px) {
        .MuiTabs-flexContainer {
          display: flex;
          justify-content: space-around;
        }

        .MuiTabs-indicator {
          display: block;
          background-color: ${UHCDesignTokens.color.ghost_uh};
          height: 8px;
          bottom: 0px;
          transform: scale(0.8);
        }

        .MuiButtonBase-root {
          border: none;
          flex-grow: unset;
          height: 48px;
          padding: 0 24px;
          min-width: 160px;
          color: ${UHCDesignTokens.color.carbon};
        }

        .Mui-selected {
          background-color: unset;
          color: ${UHCDesignTokens.color.carbon};
          font-weight: bolder;
          border-bottom: none;
          font-weight: bold;
          letter-spacing: 0px;
          color: #333;
        }
      }
    }
  `}
`;

type StyledBadgeProps = {leftPosition: number}

export const StyledBadge = styled(Badge)<StyledBadgeProps>`
  position: absolute;

  left: ${(props) => `${props.leftPosition}px`};
  top: -11px
`